'use client';

import { track } from '@vercel/analytics';
import Link from 'next/link';

// One Vercel Web Analytics custom event for the home page's link tree. The Pro
// plan keeps two properties per event; this event uses one, the link's label.
// The analytics script sends with fetch keepalive, so the event also survives
// a click that leaves the site (the Discord invite).
const HOME_LINK_CLICKED = 'Home Link Clicked';

export function HomeLink({ href, label }: { href: string; label: string }) {
  return (
    <Link
      href={href}
      className="hover:underline focus-visible:underline"
      onClick={() => track(HOME_LINK_CLICKED, { link: label })}
    >
      {label}
    </Link>
  );
}
